
const getPageLabel = (total, pageSize, pageNr) => {
	const getPageStart = (pagesize, pagenr) => {
		return pagesize * pagenr;
	};
	const start = Math.max(
		getPageStart(pageSize, pageNr),
		0
	);
	const end = Math.min(
		getPageStart(pageSize, pageNr + 1),
		total
	);

	return `${start + 1} - ${end}`;
}

export default getPageLabel
